import { TOKEN_RESET } from '@/constants/token'
import { BACKEND_PRIVATE, BACKEND_PUBLIC } from '../base'

/**
 * Sign Up User
 * @param fields
 * @param reCaptcha
 * @returns {AxiosPromise<any>}
 */
export async function signUp(fields: any, reCaptcha: string) {
  return BACKEND_PUBLIC.post('/users/register', {
    payload: {
      ...fields,
      reCaptcha,
    },
  })
}

/**
 * Sign Up User (Social)
 * @param fields
 * @param token
 * @returns {AxiosPromise<any>}
 */
export async function signUpSocial(fields: any, token: string) {
  return BACKEND_PUBLIC.post(
    '/users/social-register',
    {
      payload: {
        ...fields,
      },
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
}

/**
 * Sign In User
 * @param login
 * @param password
 * @param reCaptcha
 * @returns {Promise<*>}
 */
export async function signIn({ login, password, reCaptcha, key }: { login: string; password: string; reCaptcha: string; key?: string }) {
  return BACKEND_PUBLIC.post('/users/temp-auth', {
    payload: {
      login,
      password,
      reCaptcha,
      key,
    },
  })
}

/**
 * Sign Out User
 * @returns {Promise<*>}
 */
export async function signOut() {
  return BACKEND_PRIVATE.post('/users/logout')
}

/**
 * Activate User Account
 * @param token
 * @returns {AxiosPromise<any>}
 */
export function activate(token: string) {
  return BACKEND_PUBLIC.post('/users/activate', {
    payload: {
      token,
    },
  })
}

/**
 * Resend Password
 * @param email
 * @param reCaptcha
 * @returns {AxiosPromise<any>}
 */
export function resend(email: string, reCaptcha: string) {
  return BACKEND_PUBLIC.post('/users/resend-activation-mail', {
    payload: {
      email,
      reCaptcha,
    },
  })
}

/**
 * Forgot Password
 * @param email
 * @param reCaptcha
 * @returns {AxiosPromise<any>}
 */
export function forgot(email: string, reCaptcha: string) {
  return BACKEND_PUBLIC.post('/users/forgot', {
    payload: {
      email,
      reCaptcha,
    },
  })
}

export function reset(token: string, password: string, key?: string) {
  return BACKEND_PUBLIC.post('/users/reset-password', {
    payload: {
      token,
      password,
      passwordConfirm: password,
      key,
    },
  })
}

export function isValidToken(token: string) {
  return BACKEND_PUBLIC.post('/users/token-is-valid', {
    payload: {
      token,
      type: TOKEN_RESET,
    },
  })
}

export async function exchangeSocialTemporaryToken(token: string, key?: string) {
  return BACKEND_PUBLIC.post('/users/exchange-social-temporary-token', {
    payload: {
      token,
      key,
    },
  })
}

/**
 * Sign Up and Login User by signature
 * @param fields
 * @param reCaptcha
 * @returns {AxiosPromise<any>}
 */
export async function cryptoAuth(fields: any, reCaptcha: string) {
  return BACKEND_PUBLIC.post('users/crypto-auth', {
    payload: {
      ...fields,
      reCaptcha,
    },
  })
}
